import { render, staticRenderFns } from "./SeguimientoFallas.vue?vue&type=template&id=06f1782e&scoped=true"
import script from "./SeguimientoFallas.vue?vue&type=script&lang=js"
export * from "./SeguimientoFallas.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoFallas.vue?vue&type=style&index=0&id=06f1782e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1782e",
  null
  
)

export default component.exports